<template>
	<select title="title">
		<option v-if="placeholder" value="">{{placeholder}}</option>
		<slot name="defaultValue"></slot>
		<slot></slot>
	</select>
</template>

<script>
	import select2 from 'select2'
	import 'select2/dist/css/select2.min.css'

	export default {
		name: "Select2",
		props: ['options', 'value', 'url', 'label', 'id', 'multiple', "placeholder", "httpOptions"],
		computed: {
			isGet() {
				return this.httpOptions.method === 'GET'
			}
		},
		mounted() {
			let that = this;
			let config = {};
            

			if(this.label && this.options !== undefined) {
				config.data = this.options.map(this.convertOptions);
			} else {
				config.data = this.options;
			}

			if(this.httpOptions !== undefined) {
				config.ajax = {
					url: this.httpOptions.url,
					method: this.httpOptions.method,
					dataType: 'json',
					delay: 250,
					[this.isGet ? 'params' : 'data']: this.httpOptions.data,
					processResults(data) {
						let filtered = data.data.map(that.convertOptions);

						return {
							results: filtered
						}
					},
					cache: true
				};
				config.minimumInputLength = 3;
			}

			let $el = $(this.$el)
				.select2(config)
				.attr('multiple', this.multiple)
				.on('change', function() {
					that.$emit('change', this.value);
					that.$emit('input', this.value);
				});

			if(this.value) {
				$el.val(this.value).trigger('change');
			}
		},
		data() {
			return {
				multipleValue: []
			}
		},
		methods: {
			convertOptions(item) {
				return {
					text: item[this.label],
					id: this.id ? item[this.id] : item
				}
			},
			getMultipleValue(value) {
				if(this.multipleValue.indexOf(value) === -1) {
					this.multipleValue.push(value)
				} else {
					this.multipleValue.splice(this.multipleValue.indexOf(value), 1)
				}

				return this.multipleValue
			}
		},
		watch: {
			value(value) {
				if(this.multiple) {
					$(this.$el).val(this.getMultipleValue(value)).trigger('change');
				} else {
					$(this.$el).val(value).trigger('change');
				}
			},
			options(options) {
				if(this.label && this.id) {
					$(this.$el).select2({data: options.map(this.convertOptions)})
				} else {
					$(this.$el).select2({data: options})
				}
			}
		},
		destroyed: function() {
			$(this.$el).off().select2('destroy')
		}
	}
</script>



// WEBPACK FOOTER //
// Select2.vue?8ead3a42